import * as types from '@/store/types';

export default {
  [types.FECTH_STORIES](state, { stories }){
    state.stories = stories;
    //state.story = story;
  },
  [types.FECTH_STORY](state, { story }){
    state.story = story;
  },

};
